import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["attribute", "group"]

  connect() {
    this.options = Array.from(this.groupTarget.querySelectorAll("option[data-attribute-id]"))
    this.render()
  }

  filter() {
    this.render()
    this.groupTarget.value = ""
  }

  render() {
    const attributeId = this.attributeTarget.value
    const selected = this.groupTarget.value

    this.options.forEach(option => option.remove())
    this.options
      .filter(option => option.dataset.attributeId === attributeId)
      .forEach(option => this.groupTarget.appendChild(option))

    this.groupTarget.value = selected
  }
}
